import React, { useState } from "react";
import Quotation from "../../../images/TrustedByMany/quotation.svg";
import { IoArrowForward, IoStar, IoStarOutline } from "react-icons/io5";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import Popups from "../Popups";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import Image from "next/image";
import { DotButton, useDotButton } from "./EmblaCarouselDotButton";
import useEmblaCarousel from "embla-carousel-react";

const TrustedByMany = ({ data, page }) => {
  const [showModal, setShowModal] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({ align: "start", loop: true });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const showRatings = (ratings) => {
    let unratedRating = 5 - ratings;
    let rated = [];
    let unrated = [];

    while (ratings > 0) {
      rated.push("");
      ratings--;
    }

    while (unratedRating > 0) {
      unrated.push("");
      unratedRating--;
    }

    return (
      <div className={s.ratings}>
        {rated.map((rated, idx) => (
          <span key={idx} className={s.full_rating}>
            <IoStar size="24px" />
          </span>
        ))}
        {unrated.map((rated, idx) => (
          <span key={idx} className={s.unrated}>
            <IoStarOutline size="24px" />
          </span>
        ))}
      </div>
    );
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "JewelryStore",
    name: "Manhattan Buyers",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "214",
    },
    review:
      data?.testimonies?.map((item) => ({
        "@type": "Review",
        author: {
          "@type": "Person",
          name: item.name || "",
        },
        datePublished: item.date || "2025-02-01",
        reviewBody: item.reviewBody || "",
        reviewRating: {
          "@type": "Rating",
          ratingValue: item.rating || 5,
        },
      })) || [],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema),
        }}
      />
      <section className={`${s.trusted_by_many} section-center`}>
        {/* <Container> */}
        <div className={`${s.outer_container} row justify-content-between`}>
          <article className="col-md-5" style={{ padding: "0px" }}>
            <div className={s.main_container}>
              <h2 className={s.title_main}>
                {data?.trusted_by_many_title ||
                  "Trusted by many to get the top dollar"}
              </h2>
              <div className={`${s.points_container} ${secondaryFont}`}>
                {data?.points?.map(({ icon, text }, idx) => {
                  return (
                    <div key={idx} className={s.single_point}>
                      <PrismicNextImage
                        loading="lazy"
                        field={icon}
                        fallbackAlt=""
                      />
                      <p>{text}</p>
                    </div>
                  );
                })}
              </div>
              <button
                className={`btn btn-primary ${secondaryFont}`}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Get an offer now{" "}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </button>
            </div>
          </article>
          <article className={`col-md-7`}>
            <div className="embla_testimonials">
              <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                  {data?.testimonies?.map(
                    ({ testimony, name, title, ratings }, idx) => (
                      <div className={`embla__slide`} key={idx}>
                        <div className={`${secondaryFont} ${s.testimony}`}>
                          <Image
                            loading="lazy"
                            src={Quotation.src}
                            alt="image"
                            height={100}
                            width={100}
                          />
                          <div className={secondaryFont}>
                            <PrismicRichText field={testimony || []} />
                          </div>
                          <p className={`${secondaryFont} ${s.name}`}>{name}</p>
                          <p className={`${secondaryFont} ${s.title}`}>
                            {title}
                          </p>
                          {showRatings(ratings)}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>

              <div className="embla__controls__testinomials">
                <div className="embla__dots">
                  {scrollSnaps.map((_, index) => (
                    <DotButton
                      key={index}
                      onClick={() => onDotButtonClick(index)}
                      className={"embla__dot".concat(
                        index === selectedIndex ? " embla__dot--selected" : "",
                      )}
                    />
                  ))}
                </div>
              </div>
            </div>
          </article>
        </div>
        <Popups
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          page={page}
        />
      </section>
    </>
  );
};

export default TrustedByMany;
